import { render, staticRenderFns } from "./MyCourseList.vue?vue&type=template&id=316fcc34&scoped=true&"
import script from "./MyCourseList.vue?vue&type=script&lang=js&"
export * from "./MyCourseList.vue?vue&type=script&lang=js&"
import style0 from "./MyCourseList.vue?vue&type=style&index=0&id=316fcc34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316fcc34",
  null
  
)

export default component.exports